import React, { useEffect, useState } from "react";
import { IoCameraOutline } from "react-icons/io5";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TbCameraPlus } from "react-icons/tb";

import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { useSelector } from "react-redux";

const UploadPhoto = () => {
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);
  const [imgFile, setImgFile] = useState();
  const [previewImage, setPreviewImage] = useState();
  const { loading, postRequest } = {};

  useEffect(() => {
    if (imgFile && imgFile.type.startsWith("image")) {
      setPreviewImage(URL.createObjectURL(imgFile));
    } else {
      URL.revokeObjectURL(previewImage);
    }

    if (!open) {
      setImgFile("");
    }
  }, [imgFile, open]);

  async function uploadImage(e) {
    e.preventDefault();
    if (imgFile && imgFile.size > 2 * 1024 * 1024) {
      toast.error("File size exceeds 2 MB. Please select a smaller file.", {
        duration: 2000,
      });
      return;
    }

    if (imgFile) {
      const formDataToSend = new FormData();
      formDataToSend.append("image", imgFile);
      const { onSuccess, data } = await postRequest(
        `/api/user/profile/${user.id}`,
        formDataToSend,
      );
      if (onSuccess) {
        // console.log(data);
        toast.success("Updated successfully!", { duration: 1000 });
        setOpen(false);
      }
    }
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
          <IoCameraOutline size={20} className="text-primary" />
        </div>

        <div onClick={() => setOpen(true)} className="cursor-pointer">
          <h1 className="font-semibold">Upload Photo</h1>
          <p className="dark:text-darkGray text-[12px] font-medium text-gray-500">
            Reset password
          </p>
        </div>
      </div>

      {/* Pop-up */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="font-jakarta dark:bg-darkBg max-w-[314px] border-none">
          <DialogHeader>
            <DialogTitle className="text-darkInput text-xl font-bold dark:text-white">
              <div className="flex items-center justify-between pt-5">
                <h1>Upload Photo</h1>

                <h2 className="font-geist rounded-md bg-[#54d62c29] p-1 text-xs font-bold text-[#229a16]">
                  Billzpay
                </h2>
              </div>
            </DialogTitle>
          </DialogHeader>

          <div className="flex flex-col items-center justify-center py-2">
            <div className="mx-auto size-[144px] rounded-full border border-dashed border-black/85 p-2 dark:border-[#919eab52]">
              <form onSubmit={uploadImage}>
                <input
                  type="file"
                  name=""
                  id="file"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files && setImgFile(e.target.files[0])
                  }
                />

                <button
                  id="submitBtn"
                  type="submit"
                  className="hidden"
                ></button>
              </form>

              {imgFile ? (
                <img
                  src={previewImage}
                  alt="image"
                  className="size-full rounded-full object-cover"
                />
              ) : (
                <div
                  onClick={() => document.querySelector("#file").click()}
                  className="flex size-full cursor-pointer flex-col items-center justify-center gap-3 rounded-full bg-gray-200 hover:bg-gray-300 dark:bg-[#161c24]"
                >
                  <TbCameraPlus
                    size={30}
                    className="text-black dark:text-white"
                  />

                  <p className="text-[12px] font-semibold dark:text-white">
                    Update photo
                  </p>
                </div>
              )}
            </div>

            <p className="max-w-48 py-2 text-center text-[12px] dark:text-white">
              Allowed *.jpeg, *.jpg, *.png, *.gif max size of 2MB
            </p>

            {imgFile && (
              <div className="flow-row flex items-center space-x-2">
                <button
                  onClick={() => document.querySelector("#file").click()}
                  className="bg-primary rounded-md px-4 py-2.5 text-sm font-medium text-white"
                >
                  Change Image
                </button>

                <button
                  onClick={() => document.querySelector("#submitBtn").click()}
                  className={cn(
                    "bg-primary rounded-md px-4 py-2.5 text-sm font-medium text-white",
                    {
                      "opacity-65": loading,
                    },
                  )}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UploadPhoto;
